import {call, put, select} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import UserActions, {UserSelectors} from '../Redux/UserRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

//import utils from '../Utils/utils'

export function* getUsers(api, authApi, {page, page_size, sort_field, sort_order, role, search}) {
  try {
    const response = yield call(api.getUsers, page, page_size, sort_field, sort_order, role, search)
    if (response && response.ok) {
      yield put(UserActions.usersSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getUsers(api, authApi, {page, page_size, sort_field, sort_order, role, search})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getUser(api, authApi, {userId}) {
  try {
    const response = yield call(api.getUser, userId)
    if (response && response.ok) {
      yield put(UserActions.userSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getUser(api, authApi, {userId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* deleteUser(api, authApi, {id}) {
  try {
    const response = yield call(api.deleteUser, id)
    if (response && response.ok) {
      yield put(UserActions.userDeleteSuccess(response.data ? response.data : true))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* deleteUser(api, authApi, {id})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* saveUser(api, authApi, {data}) {
  try {
    const response = yield call(api.updateUser, data)
    if (response && response.ok) {
      yield put(UserActions.userSaveSuccess(response.data))
      yield put(AuthActions.updateProfile(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveUser(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* updateUserInfo(api, authApi, {userId}) {
  try {
    const response = yield call(api.getUser, userId)
    const {verificationLink} = yield select(UserSelectors.getState)

    if (response && response.ok) {
      yield put(AuthActions.updateProfile(response.data))
      if (response.data?.payment_verification) {
        if (verificationLink !== response.data?.payment_verification) {
          UserActions.setVerificationLink(response.data?.payment_verification)
          // STRIPE VERIFICATION
          // utils.goLink(response.data?.payment_verification)
        }
      }
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* updateUserInfo(api, authApi, {userId})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* saveUserAvatar(api, authApi, {data}) {
  try {
    const response = yield call(api.updateUser, data)
    if (response && response.ok) {
      yield put(UserActions.userSaveAvatarSuccess(response.data))
      yield put(AuthActions.updateProfile(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* saveUser(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* changeProfilePassword(api, authApi, {data}) {
  try {
    const response = yield call(api.changeProfilePassword, data)
    if (response && response.ok) {
      yield put(UserActions.profileChangePasswordSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* changeProfilePassword(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* changeUserPassword(api, authApi, {data}) {
  try {
    const response = yield call(api.changeUserPassword, data)
    if (response && response.ok) {
      yield put(UserActions.userChangePasswordSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* changeUserPassword(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getBusinessAreas(api, authApi) {
  try {
    const response = yield call(api.getBusinessAreas)
    if (response && response.ok) {
      yield put(UserActions.businessAreasSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getBusinessAreas(api, authApi)
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getCompanyRoles(api, authApi) {
  try {
    const response = yield call(api.getCompanyRoles)
    if (response && response.ok) {
      yield put(UserActions.companyRolesSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getCompanyRoles(api, authApi)
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getStaffList(api, authApi) {
  try {
    const response = yield call(api.getStaffList)
    if (response && response.ok) {
      yield put(UserActions.staffNumberSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getStaffList(api, authApi)
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* changeUserEmail(api, authApi, {data}) {
  try {
    const response = yield call(api.changeUserEmail, data)
    if (response && response.ok) {
      yield put(UserActions.userChangeEmailSuccess(true))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* changeUserEmail(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* confirmChangeEmail(api, authApi, {data}) {
  try {
    const response = yield call(api.confirmChangeEmail, data)
    if (response && response.ok) {
      yield put(UserActions.userConfirmCodeSuccess(true))
      yield put(UserActions.userChangeEmailReset())
      yield put(AuthActions.updateProfile(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(UserActions.userFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* confirmChangeEmail(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(UserActions.userFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
